import { Language } from '../types/PluginData'

type Dictionary = Record<string, unknown>

export const getTranslatedObject = <DataType extends Dictionary>(
    object: DataType,
    language?: Language | null
) => {
    if (!language) return object

    const data: DataType = { ...object }

    for (const key in object) {
        if (
            key + '_multi' in object &&
            typeof object[key + '_multi'] === 'string' &&
            isValidJSON(object[key + '_multi'] as string)
        ) {
            try {
                const translations = JSON.parse(
                    object[key + '_multi'] as string
                ) as Dictionary
                if (language.jtl in translations) {
                    data[key] = translations[language.jtl] as DataType[Extract<
                        keyof DataType,
                        string
                    >]
                }
            } catch {
                console.log('error translation', object[key + '_multi'])
            }
        }
    }

    return data
}

const isValidJSON = (str: string) => {
    try {
        JSON.parse(str)
        return true
    } catch (e) {
        return false
    }
}
